// extracted by mini-css-extract-plugin
export default {"p":"Input_p__wT7N3"};